import { render } from "./garantiaCard.vue?vue&type=template&id=e7331cea&scoped=true"
import script from "./garantiaCard.vue?vue&type=script&lang=js"
export * from "./garantiaCard.vue?vue&type=script&lang=js"

import "./garantiaCard.vue?vue&type=style&index=0&id=e7331cea&lang=css"
import "./garantiaCard.vue?vue&type=style&index=1&id=e7331cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7331cea"]])

export default __exports__